export const footerSection = {
  instagramLink: {
    include: false,
    url: "",
  },
  facebookLink: {
    include: true,
    url: "",
  },
  twitterLink: {
    include: true,
    url: "",
  },
  copyright: "2023 by Fullstacktuts LLC, All rights reserved.",
  location: {
    include: true,
    address: "123 AppLander St., 2nd Floor",
  },
  phone: {
    include: true,
    phone: "415-201-6370",
  },
  email: {
    include: true,
    email: "hello@example.com",
  },
};

/*
  DOCUMENTATION

  --instagramLink
  Make include "true" if you would like to include an Instagram link. Use url to specify your Instagram page.
  --facebookLink
  Make include "true" if you would like to include a Facebook link. Use url to specify your Facebook page.
  --twitterLink
  Make include "true" if you would like to include a Twitter link. Use url to specify your Twitter page.
  --copyright
  The copyright to your website
  --location
  Make include "true" to reveal this part. Make it "false" to hide.
  --phone
  Make include "true" to reveal this part. Make it "false" to hide.
  --email
  Make include "true" to reveal this part. Make it "false" to hide.

*/
